/*
 * M.E.R.L.İ.N — Project Fairy / purple live presence.
 * This layer owns presentation, position and gestures only. Existing
 * data-merlin-trigger delegation remains the advisor/context authority.
 */
(function initMerlinFairyPresence() {
  'use strict';
  var RUNTIME_KEY = '__LASIRIUS_MERLIN_FAIRY__';
  var POSITION_KEY = 'lasirius:merlin-fairy:vector-position:v2';
  var VISIT_KEY = 'lasirius:merlin-fairy:materialization-seen:v1';
  var WELCOME_KEY = 'lasirius:merlin-fairy:welcome-seen:v1';
  var PAGE_KEY = 'lasirius:merlin-fairy:last-page:v1';
  var REENTRY_KEY = 'lasirius:merlin-fairy:reentry:v1';
  var historyEntryKey = 'lasiriusFairyEntry';
  var fallbackEntry = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
  // Distinguish history entries without copying private search/hash data.
  function pageIdentity() {
    var entry = window.navigation?.currentEntry?.key;
    if (!entry) {
      var state = window.history.state;
      if (!state || typeof state === 'object') {
        entry = state && state[historyEntryKey] || fallbackEntry;
        if (!state || !state[historyEntryKey]) {
          try { window.history.replaceState(Object.assign({}, state, { [historyEntryKey]: entry }), ''); } catch (_) {}
        }
      } else entry = fallbackEntry;
    }
    return window.location.origin + window.location.pathname + '#' + entry;
  }
  var MESSAGES = [
    'Her türlü sorunuz için bana danışabilirsiniz',
    'Merlin asistanlık için burada',
    'Bir ürün seçerken size eşlik edebilirim',
    'Beden, renk ve detayları birlikte inceleyebiliriz',
  ];
  if (window[RUNTIME_KEY]) return;

  function boot() {
    var root = document.querySelector('[data-merlin-fairy]');
    if (!root || root.dataset.mounted === 'true') return;
    var trigger = root.querySelector('[data-merlin-fairy-trigger]');
    if (!trigger) return;
    var trail = document.querySelector('[data-merlin-fairy-trail]');
    var tether = document.querySelector('[data-merlin-fairy-tether]');
    var magic = document.querySelector('[data-merlin-fairy-magic]');
    var puppet = root.querySelector('[data-fairy-puppet]');
    var star = root.querySelector('.merlin-fairy__wand path:nth-of-type(2)');
    var messageNode = root.querySelector('[data-fairy-message]');
    var welcome = root.querySelector('[data-fairy-welcome]');
    var messageBurst = root.querySelector('[data-fairy-message-burst]');
    var panel = document.getElementById('merlin-advisor-backdrop');
    var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var fineQuery = window.matchMedia('(any-pointer: fine)');
    var runtime = {
      root: root, trigger: trigger, trail: trail, tether: tether, magic: magic,
      state: 'hidden', pointer: null, hover: null, magicRun: null, magicAnimations: [],
      ignoreClickUntil: 0,
      position: { x: 0, y: 0 }, target: { x: 0, y: 0 },
      size: { width: 160, height: 240 }, viewport: { width: 0, height: 0 },
      raf: 0, resizeRaf: 0, arrivalStarted: 0, arrivalDuration: 0,
      arrivalTimer: 0, settleTimer: 0, openingTimer: 0, welcomeTimer: 0,
      messageTimer: 0, messagePulseTimer: 0, messageIndex: 0, suppressClickUntil: 0,
      panelWasOpen: false, paused: false, observer: null,
      tetherOrigin: null, tetherOriginAt: 0,
      trailNodes: trail ? Array.from(trail.querySelectorAll('[data-fairy-particle]')) : [],
      tetherNodes: tether ? Array.from(tether.querySelectorAll('[data-tether-particle]')) : [],
      magicNodes: magic ? Array.from(magic.querySelectorAll('[data-magic-particle]')) : [],
    };
    root.dataset.mounted = 'true';
    window[RUNTIME_KEY] = runtime;

    function readStorage(key, sessionOnly) {
      if (!sessionOnly) {
        try { var local = window.localStorage.getItem(key); if (local) return local; } catch (_) {}
      }
      try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
    }
    function writeStorage(key, value, sessionOnly) {
      if (!sessionOnly) {
        try { window.localStorage.setItem(key, value); return; } catch (_) {}
      }
      try { window.sessionStorage.setItem(key, value); } catch (_) {}
    }
    function readPageMarker() {
      var stored = readStorage(PAGE_KEY, true);
      if (stored) return stored;
      try { var nameState = JSON.parse(window.name || '{}'); return nameState[PAGE_KEY] || null; } catch (_) { return null; }
    }
    function readVisitMarker() {
      var stored = readStorage(VISIT_KEY, true);
      if (stored) return stored;
      try { var nameState = JSON.parse(window.name || '{}'); return nameState[VISIT_KEY] || null; } catch (_) { return null; }
    }
    function writeVisitMarker(value) {
      writeStorage(VISIT_KEY, value, true);
      try {
        var nameState = JSON.parse(window.name || '{}');
        nameState[VISIT_KEY] = value;
        window.name = JSON.stringify(nameState);
      } catch (_) {}
    }
    function clearVisitMarker() {
      try { window.sessionStorage.removeItem(VISIT_KEY); } catch (_) {}
      try {
        var nameState = JSON.parse(window.name || '{}');
        delete nameState[VISIT_KEY];
        window.name = JSON.stringify(nameState);
      } catch (_) {}
    }
    function writePageMarker(value) {
      writeStorage(PAGE_KEY, value, true);
      try {
        var nameState = JSON.parse(window.name || '{}');
        nameState[PAGE_KEY] = value;
        window.name = JSON.stringify(nameState);
      } catch (_) {}
    }
    function prepareWelcomeEntry() {
      // A direct/external return is a new visit. Same-origin navigation keeps
      // the one-time welcome quiet across the site's internal pages.
      var referrer = document.referrer;
      var external = !referrer;
      if (referrer) {
        try { external = new URL(referrer, window.location.href).origin !== window.location.origin; } catch (_) { external = true; }
      }
      var navigation = performance.getEntriesByType('navigation')[0];
      var previousPage = readPageMarker();
      var previousSameOrigin = false;
      try { previousSameOrigin = previousPage && new URL(previousPage, window.location.href).origin === window.location.origin; } catch (_) {}
      if (previousSameOrigin && !referrer) external = false;
      if (previousSameOrigin && referrer) {
        try { if (new URL(referrer, window.location.href).origin === window.location.origin) external = false; } catch (_) {}
      }
      if (navigation && navigation.type === 'back_forward') external = previousPage === pageIdentity();
      if (navigation && navigation.type === 'reload') external = readStorage(REENTRY_KEY, true) === 'true';
      if (external) {
        try { window.sessionStorage.removeItem(WELCOME_KEY); } catch (_) {}
        clearVisitMarker();
      }
      try { window.sessionStorage.removeItem(REENTRY_KEY); } catch (_) {}
      writePageMarker(pageIdentity());
    }
    function hideWelcome() {
      clearTimer('welcomeTimer');
      if (welcome) welcome.dataset.state = 'hidden';
      root.dataset.welcome = 'hidden';
    }
    function showWelcome(first) {
      if (!first || !welcome || readStorage(WELCOME_KEY, true)) return;
      writeStorage(WELCOME_KEY, 'true', true);
      welcome.dataset.state = 'visible';
      root.dataset.welcome = 'visible';
      clearTimer('welcomeTimer');
      runtime.welcomeTimer = setTimeout(hideWelcome, 7200);
    }
    function rotateMessage() {
      if (!messageNode || runtime.paused || runtime.panelWasOpen || !canTrack()) return;
      // Snapshot the animated SVG tip before any writes. Stars depart from
      // that exact location; no per-frame DOM measurement is needed.
      var origin = messageBurst && !reducedQuery.matches ? wandPoint() : null;
      var rect = origin ? root.getBoundingClientRect() : null;
      if (origin && rect) {
        messageBurst.style.left = (origin.x - rect.left).toFixed(1) + 'px';
        messageBurst.style.top = (origin.y - rect.top).toFixed(1) + 'px';
      }
      runtime.messageIndex = (runtime.messageIndex + 1) % MESSAGES.length;
      messageNode.textContent = MESSAGES[runtime.messageIndex];
      messageNode.classList.add('is-changing');
      root.dataset.messagePulse = 'true';
      clearTimer('messagePulseTimer');
      runtime.messagePulseTimer = setTimeout(function () {
        runtime.messagePulseTimer = 0;
        root.dataset.messagePulse = 'false';
        messageNode.classList.remove('is-changing');
      }, 980);
    }
    function startMessageCycle() {
      if (!messageNode || runtime.messageTimer) return;
      messageNode.textContent = MESSAGES[runtime.messageIndex];
      runtime.messageTimer = setInterval(rotateMessage, 5000);
    }
    function stopMessageCycle() {
      if (runtime.messageTimer) clearInterval(runtime.messageTimer);
      runtime.messageTimer = 0;
      clearTimer('messagePulseTimer');
      if (messageNode) messageNode.classList.remove('is-changing');
      root.dataset.messagePulse = 'false';
    }
    function cacheGeometry() {
      runtime.viewport = { width: window.innerWidth, height: window.innerHeight };
      var mobile = runtime.viewport.width <= 740;
      runtime.size = { width: mobile ? 120 : 160, height: mobile ? 180 : 240 };
      root.style.setProperty('--fairy-width', runtime.size.width + 'px');
      root.style.setProperty('--fairy-height', runtime.size.height + 'px');
    }
    function clampPosition(x, y) {
      var view = runtime.viewport;
      return {
        x: Math.max(8, Math.min(Math.max(8, view.width - runtime.size.width - 8), Number(x) || 0)),
        // The small signature lives above the character and remains within the viewport.
        y: Math.max(30, Math.min(Math.max(30, view.height - runtime.size.height - 8), Number(y) || 0)),
      };
    }
    function setPosition(x, y, rotate) {
      runtime.tetherOrigin = null;
      var safe = clampPosition(x, y);
      runtime.position = safe;
      runtime.target = safe;
      root.style.setProperty('--fairy-x', safe.x.toFixed(1) + 'px');
      root.style.setProperty('--fairy-y', safe.y.toFixed(1) + 'px');
      root.style.setProperty('--fairy-rotate', (rotate || 0).toFixed(2) + 'deg');
      root.style.setProperty('--fairy-scale', '1');
      // Keep the larger caption readable at saved edge positions without moving
      // the character away from the place chosen by the visitor.
      var captionWidth = Math.min(286, runtime.viewport.width - 20);
      var center = safe.x + runtime.size.width / 2;
      var captionCenter = Math.max(10 + captionWidth / 2, Math.min(runtime.viewport.width - 10 - captionWidth / 2, center));
      root.style.setProperty('--fairy-caption-shift', (captionCenter - center).toFixed(1) + 'px');
      root.dataset.captionSide = safe.y < 76 ? 'below' : 'above';
    }
    function savePosition() { writeStorage(POSITION_KEY, JSON.stringify(runtime.position), false); }
    function readPosition() {
      try {
        var saved = JSON.parse(readStorage(POSITION_KEY, false));
        if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) return clampPosition(saved.x, saved.y);
      } catch (_) {}
      return null;
    }
    function setState(state) {
      runtime.state = state;
      root.dataset.state = state;
      var hidden = state === 'hidden' || state === 'panel_open' || state === 'suspended';
      root.setAttribute('aria-hidden', String(hidden));
      trigger.tabIndex = hidden ? -1 : 0;
      trigger.style.pointerEvents = hidden ? 'none' : '';
    }
    function rectFor(node) {
      if (!node || !node.isConnected) return null;
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) return null;
      var rect = node.getBoundingClientRect();
      return rect.width > 2 && rect.height > 2 ? rect : null;
    }
    function intersects(a, b, padding) {
      var p = padding || 0;
      return !(a.right + p < b.left || a.left - p > b.right || a.bottom + p < b.top || a.top - p > b.bottom);
    }
    function chooseAnchor() {
      var view = runtime.viewport, size = runtime.size;
      var mobile = view.width <= 740;
      var hero = document.querySelector('button[data-merlin-trigger="hero"]');
      if (hero) {
        var heroRect = hero.getBoundingClientRect();
        if (heroRect.width > 0 && heroRect.height > 0) {
          if (mobile) {
            return clampPosition(
              heroRect.left + heroRect.width * 0.46 - size.width * 0.5,
              heroRect.top + heroRect.height * 0.35
            );
          } else {
            return clampPosition(
              heroRect.left + heroRect.width * 0.65 - size.width * 0.5,
              heroRect.top + heroRect.height * 0.35
            );
          }
        }
      }
      var colBanner = document.querySelector('[data-merlin-trigger="collection"]');
      if (colBanner) {
        var colRect = colBanner.getBoundingClientRect();
        if (colRect.width > 0 && colRect.height > 0) {
          return clampPosition(
            colRect.left + colRect.width * (mobile ? 0.48 : 0.62) - size.width * 0.5,
            colRect.top + colRect.height * 0.28
          );
        }
      }
      var prodBanner = document.querySelector('[data-merlin-trigger="product"]');
      if (prodBanner) {
        var prodRect = prodBanner.getBoundingClientRect();
        if (prodRect.width > 0 && prodRect.height > 0) {
          return clampPosition(
            prodRect.left + prodRect.width * (mobile ? 0.48 : 0.60) - size.width * 0.5,
            prodRect.top + prodRect.height * 0.25
          );
        }
      }
      var rail = document.querySelector('.lasirius-world-links');
      if (rail) {
        var railRect = rail.getBoundingClientRect();
        if (railRect.width > 0 && railRect.height > 0) {
          return clampPosition(
            railRect.left + railRect.width * 0.68 - size.width * 0.5,
            railRect.top + Math.min(22, railRect.height * 0.14)
          );
        }
      }
      return clampPosition((view.width - size.width) / 2, (view.height - size.height) * 0.32);
    }
    function clearTimer(name) { if (runtime[name]) clearTimeout(runtime[name]); runtime[name] = 0; }
    function clearTrail() {
      if (trail) trail.dataset.state = 'hidden';
      runtime.trailNodes.forEach(function (node) {
        node.style.opacity = '0';
        node.style.transform = 'translate3d(0,0,0) scale(0)';
      });
    }
    function clearTether() {
      if (tether) tether.dataset.state = 'hidden';
      runtime.tetherNodes.forEach(function (node) { node.style.opacity = '0'; });
    }
    function clearMagic() {
      runtime.magicRun = null;
      if (runtime.magicAnimations && runtime.magicAnimations.length) {
        runtime.magicAnimations.forEach(function (anim) {
          try { anim.cancel(); } catch (_) {}
        });
        runtime.magicAnimations = [];
      }
      if (magic) { magic.dataset.state = 'hidden'; magic.dataset.active = 'false'; }
      runtime.magicNodes.forEach(function (node) {
        node.style.opacity = '0';
        node.style.transform = 'translate3d(0,0,0) scale(0)';
      });
    }
    function canTrack() { return !runtime.paused && (runtime.state === 'idle' || runtime.state === 'docked'); }
    function stopFrames() { if (runtime.raf) cancelAnimationFrame(runtime.raf); runtime.raf = 0; }
    function scheduleFrame() { if (!runtime.raf && !runtime.paused) runtime.raf = requestAnimationFrame(frame); }

    function wandPoint() {
      var pos = runtime.position, size = runtime.size;
      if (!pos || !size) return null;
      // Fixed wand star tip on puppet: (78.75%, 32.08%) - 0ms O(1) math, zero reflow, 120 FPS
      return {
        x: pos.x + size.width * .7875,
        y: pos.y + size.height * .3208
      };
    }
    function curvePoint(from, to, progress, now, ripple) {
      var dx = to.x - from.x, dy = to.y - from.y;
      var distance = Math.hypot(dx, dy) || 1;
      var bend = Math.min(48, distance * .085) * Math.sin(Math.PI * progress);
      var tremor = (ripple || 0) * Math.sin(now / 240 + progress * 13) * Math.sin(Math.PI * progress);
      return {
        x: from.x + dx * progress - dy / distance * (bend + tremor),
        y: from.y + dy * progress + dx / distance * (bend + tremor),
      };
    }
    function paintMaterialization(now) {
      if (!runtime.isFirstVisit) return false;
      var p = Math.min(1, (now - runtime.arrivalStarted) / runtime.arrivalDuration);
      var fade = Math.sin(Math.PI * p);
      var cx = runtime.position.x + runtime.size.width * .5;
      var cy = runtime.position.y + runtime.size.height * .53;
      var total = runtime.trailNodes.length || 1;
      runtime.trailNodes.forEach(function (node, index) {
        var angle = (index * Math.PI * 2 / total) + p * 2.8;
        // Spiraling stardust: starts widely orbiting, contracts smoothly inward as fairy blooms
        var radius = (1 - p) * 1.1 + 0.14 + (p > 0.8 ? (p - 0.8) * 1.5 : 0);
        var x = cx + Math.cos(angle) * runtime.size.width * .62 * radius;
        var y = cy + Math.sin(angle) * runtime.size.height * .52 * radius;
        var scale = (0.35 + Math.sin(p * Math.PI) * 0.85).toFixed(2);
        var opacity = (fade * (0.65 + (index % 3) * 0.18)).toFixed(3);
        node.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + scale + ')';
        node.style.opacity = opacity;
      });
      return p < 1;
    }
    function paintTether(now, origin) {
      var hover = runtime.hover;
      if (!hover || !origin || !canTrack() || reducedQuery.matches) { clearTether(); return false; }
      var smoothing = hover.isTouch ? .45 : .30;
      hover.smoothX += (hover.x - hover.smoothX) * smoothing;
      hover.smoothY += (hover.y - hover.smoothY) * smoothing;
      if (tether) tether.dataset.state = 'tracking';
      runtime.tetherNodes.forEach(function (node, index) {
        var p = (index + 1) / (runtime.tetherNodes.length + 1);
        var point = curvePoint(origin, { x: hover.smoothX, y: hover.smoothY }, p, now, 2.0);
        var scale = (.6 + (1 - p) * .45 + Math.sin(now / 220 + index) * .07).toFixed(2);
        node.style.transform = 'translate3d(' + point.x.toFixed(1) + 'px,' + point.y.toFixed(1) + 'px,0) scale(' + scale + ')';
        node.style.opacity = (.75 + (1 - p) * .25).toFixed(3);
      });
      return Math.abs(hover.x - hover.smoothX) > .35 || Math.abs(hover.y - hover.smoothY) > .35;
    }
    function paintMagic(now) {
      var run = runtime.magicRun;
      if (!run) return false;
      var rawP = (now - run.started) / run.duration;
      var p = Math.min(1, Math.max(0, rawP));
      var total = runtime.magicNodes.length;

      if (p >= 1) {
        var onArrival = run.onArrival;
        runtime.magicRun = null;
        // Clean up particles immediately: zero residue guaranteed!
        runtime.magicNodes.forEach(function (node) {
          node.style.opacity = '0';
          node.style.transform = 'translate3d(0,0,0) scale(0)';
        });
        magic.style.setProperty('--impact-x', run.to.x.toFixed(1) + 'px');
        magic.style.setProperty('--impact-y', run.to.y.toFixed(1) + 'px');
        magic.dataset.active = 'true';
        magic.dataset.state = 'impact';
        if (typeof onArrival === 'function') {
          try { onArrival(); } catch (_) {}
        }
        return false;
      }

      // 120Hz Cubic Ease-Out: Rapid rocket burst from wand, graceful aerodynamic deceleration to target
      var easeP = 1 - Math.pow(1 - p, 2.8);

      var dx = run.to.x - run.from.x;
      var dy = run.to.y - run.from.y;
      var distance = Math.hypot(dx, dy) || 1;
      // Elegant aerodynamic arc bend
      var bendMax = Math.min(38, distance * .075);

      runtime.magicNodes.forEach(function (node, index) {
        // Trailing particles follow lead closely and converge smoothly into target
        var lag = (index / total) * 0.14;
        var particleProgress = Math.max(0, Math.min(1, easeP - lag * (1 - easeP)));

        // Sweeping arc
        var arc = bendMax * Math.sin(Math.PI * particleProgress);
        var px = run.from.x + dx * particleProgress - (dy / distance) * arc;
        var py = run.from.y + dy * particleProgress + (dx / distance) * arc;

        var scale = (.72 + (1 - index / total) * .68).toFixed(2);
        // Bright luminous opacity that stays visible and converges right into target
        var opacity = (particleProgress < 0.05)
          ? (particleProgress / 0.05)
          : Math.min(1, (1 - index / total * 0.2) * 1.5);

        var rot = ((now * 0.75 + index * 45) % 360).toFixed(0);
        node.style.transform = 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0) scale(' + scale + ') rotate(' + rot + 'deg)';
        node.style.opacity = opacity.toFixed(3);
      });
      return true;
    }
    function frame(now) {
      runtime.raf = 0;
      if (runtime.paused) return;
      // Pointer motion still paints every frame. The slowly breathing wand
      // needs at most one SVG layout read per 48ms; casts/bursts use exact reads.
      var origin = (runtime.hover && canTrack()) ? wandPoint() : null;
      var more = runtime.state === 'materializing' && paintMaterialization(now);
      more = paintTether(now, origin) || more;
      more = paintMagic(now) || more;
      if (more) scheduleFrame();
    }
    function cancelMaterialization() {
      clearTimer('arrivalTimer');
      clearTrail();
      if (runtime.state === 'materializing') setState('idle');
    }
    function materialize(first) {
      cancelMaterialization();
      clearTimer('settleTimer');
      if (runtime.paused || document.visibilityState === 'hidden') { setState('suspended'); return; }
      if (runtime.panelWasOpen) { setState('panel_open'); return; }
      if (reducedQuery.matches) { setState('idle'); showWelcome(first); return; }
      runtime.isFirstVisit = Boolean(first);
      runtime.arrivalStarted = performance.now();
      runtime.arrivalDuration = first ? 1200 : 760;
      if (root.dataset.quality === 'reduced') runtime.arrivalDuration = first ? 950 : 620;
      root.style.setProperty('--fairy-materialize-duration', runtime.arrivalDuration + 'ms');
      setState('materializing');
      if (trail && first) {
        trail.dataset.state = 'materializing';
        scheduleFrame();
      }
      if (first) showWelcome(true);
      runtime.arrivalTimer = setTimeout(function () {
        runtime.arrivalTimer = 0;
        if (runtime.state !== 'materializing') return;
        clearTrail(); setState('settling');
        runtime.settleTimer = setTimeout(function () {
          runtime.settleTimer = 0;
          if (runtime.state === 'settling') { setState('idle'); }
        }, 220);
      }, runtime.arrivalDuration);
    }
    function finalizeDrop() {
      clearTimer('settleTimer');
      setPosition(runtime.position.x, runtime.position.y, 0);
      savePosition();
      var view = runtime.viewport, size = runtime.size, p = runtime.position;
      var near = p.x <= 18 || p.y <= 40 || p.x >= view.width - size.width - 18 || p.y >= view.height - size.height - 18;
      setState(near ? 'docked' : 'idle');
      root.style.transition = '';
      runtime.settleTimer = setTimeout(function () { runtime.settleTimer = 0; if (runtime.state === 'docked') setState('idle'); }, 380);
    }
    function scheduleClamp() {
      if (runtime.resizeRaf) return;
      runtime.resizeRaf = requestAnimationFrame(function () {
        runtime.resizeRaf = 0;
        cacheGeometry();
        setPosition(runtime.position.x, runtime.position.y, 0);
        if (runtime.pointer) runtime.pointer = null;
        if (runtime.state === 'dragging') finalizeDrop();
        // Resizing is not a visitor drag and must not create a saved anchor.
      });
    }
    function isGalleryControl(node) {
      return node.matches('[data-avize-gallery-previous], [data-avize-gallery-next], [data-avize-gallery-thumbnail], .slideshow-control, [data-media-previous], [data-media-next], [data-media-select]')
        || Boolean(node.closest('[data-avize-gallery-previous], [data-avize-gallery-next], [data-avize-gallery-thumbnail], .slideshow-control, [data-media-previous], [data-media-next], [data-media-select]'));
    }
    function isPhotoSurface(node) {
      if (isGalleryControl(node)) return false;
      // Product cards in grids/collections are clickable products, never inert surfaces
      if (node.closest('product-card, .product-card, .lasirius-card, [data-product-id]')) return false;
      if (node.matches('[data-avize-gallery-slide], .avize-product__media-slide, .product-media-container__zoom-button, slideshow-slide')) return true;
      return Boolean(node.closest('.product-media-container__zoom-button, [data-avize-gallery-slide]'));
    }
    function labelControl(node) {
      if (!node.matches('label')) return null;
      var control = node.control || (node.htmlFor && document.getElementById(node.htmlFor));
      return control && !control.disabled ? control : null;
    }
    function actionableTarget(event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return null;
      if (target.closest('[data-merlin-fairy], #merlin-advisor-backdrop, [inert], [aria-disabled="true"]')) return null;

      // 1. Product Cards (in category pages, collection grids, search, recommendations)
      var productCard = target.closest('product-card, .product-card, .lasirius-card, [data-product-id]');
      if (productCard) {
        // If clicking an inner interactive control like swatches or quick-add
        var innerControl = target.closest('button, input, select, label, [role="button"]');
        if (innerControl) {
          if (innerControl.matches(':disabled')) return null;
          return rectFor(innerControl) ? innerControl : null;
        }
        // Otherwise any click on product card (image, title, card space) navigates to product!
        var productAnchor = target.closest('a[href]') || productCard.querySelector('a.product-card__link, a[href*="/products/"], a[href]');
        if (productAnchor && rectFor(productCard)) {
          return productAnchor;
        }
      }

      // 2. Standard interactive elements
      var node = target.closest('a[href], button, input:not([type="hidden"]), select, summary, label, [role="button"], [data-merlin-trigger]');
      if (!node) return null;
      if (node.matches(':disabled')) return null;
      if (isPhotoSurface(node)) return null;
      if (node.matches('label') && !labelControl(node)) return null;
      if (node.matches('input') && !node.matches('[type="submit"], [type="button"], [type="reset"], [type="checkbox"], [type="radio"]')) return null;
      // Shopify variant radios are intentionally visually hidden; pulse their
      // visible label so the real size/color control still receives feedback.
      if (node.matches('input') && !rectFor(node)) {
        var label = node.closest('label');
        if (!label && node.id) label = document.querySelector('label[for="' + CSS.escape(node.id) + '"]');
        if (label && labelControl(label) && rectFor(label)) node = label;
      }
      return rectFor(node) ? node : null;
    }
    function startMagicRun(from, to, duration, onArrival) {
      if (!magic) {
        if (typeof onArrival === 'function') onArrival();
        return;
      }
      clearMagic();
      clearTether();
      runtime.hover = null; // Shut off tether loop for zero GPU/CPU contention

      var flightDuration = duration || 220;
      var total = runtime.magicNodes.length;
      var dx = to.x - from.x;
      var dy = to.y - from.y;
      var distance = Math.hypot(dx, dy) || 1;
      var bendMax = Math.min(36, distance * .07);

      var canAnimate = typeof Element.prototype.animate === 'function';

      if (canAnimate && total > 0) {
        magic.dataset.state = 'pulse';
        runtime.magicAnimations = [];

        var numSteps = 8;
        var leadFinished = false;

        var onFlightComplete = function () {
          if (leadFinished) return;
          leadFinished = true;
          // Cancel active WAAPI animations
          if (runtime.magicAnimations) {
            runtime.magicAnimations.forEach(function (a) { try { a.cancel(); } catch(_) {} });
            runtime.magicAnimations = [];
          }
          runtime.magicNodes.forEach(function (node) {
            node.style.opacity = '0';
            node.style.transform = 'translate3d(0,0,0) scale(0)';
          });
          // Trigger impact burst at exact arrival coordinate
          magic.style.setProperty('--impact-x', to.x.toFixed(1) + 'px');
          magic.style.setProperty('--impact-y', to.y.toFixed(1) + 'px');
          magic.dataset.active = 'true';
          magic.dataset.state = 'impact';
          if (typeof onArrival === 'function') {
            try { onArrival(); } catch (_) {}
          }
        };

        var safetyTimeout = setTimeout(onFlightComplete, flightDuration + 60);

        runtime.magicNodes.forEach(function (node, index) {
          var keyframes = [];
          for (var s = 0; s <= numSteps; s++) {
            var p = s / numSteps;
            var arc = bendMax * Math.sin(Math.PI * p);
            var px = from.x + dx * p - (dy / distance) * arc;
            var py = from.y + dy * p + (dx / distance) * arc;
            var rot = (p * 540 + index * 50) % 360;
            var scale = index === 0
              ? (p < 0.2 ? 0.7 + p * 3.0 : (p > 0.85 ? 1.3 - (p - 0.85) * 1.5 : 1.3))
              : (.75 + (1 - index / total) * .65);
            var opacity = p === 0 ? 0 : (p < 0.1 ? 1 : (p > 0.95 ? 0.85 : 1));

            keyframes.push({
              transform: 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0) scale(' + scale.toFixed(2) + ') rotate(' + rot.toFixed(0) + 'deg)',
              opacity: opacity
            });
          }

          var delay = index * 12;
          try {
            var anim = node.animate(keyframes, {
              duration: flightDuration,
              delay: delay,
              easing: 'cubic-bezier(0.16, 0.95, 0.28, 1)',
              fill: 'forwards'
            });

            runtime.magicAnimations.push(anim);

            if (index === 0) {
              anim.onfinish = function () {
                clearTimeout(safetyTimeout);
                onFlightComplete();
              };
            }
          } catch (_) {
            if (index === 0) setTimeout(onFlightComplete, flightDuration);
          }
        });

        return;
      }

      // RAF Fallback if animate is unsupported
      runtime.magicRun = {
        from: from,
        to: to,
        started: performance.now(),
        duration: flightDuration,
        onArrival: onArrival
      };
      magic.dataset.state = 'pulse';
      scheduleFrame();
    }
    function handleActionableClick(event) {
      if (runtime.executingAction || !canTrack() || reducedQuery.matches) return;
      if (event.button > 0) return;

      var target = actionableTarget(event);
      if (!target) return;

      var from = wandPoint();
      if (!from) return;

      var rect = target.getBoundingClientRect();
      var clickX = event.clientX;
      var clickY = event.clientY;
      var to;
      // Exact click coordinate: star flies precisely where finger/mouse touched!
      if (clickX > 0 || clickY > 0) {
        to = { x: clickX, y: clickY };
      } else if (runtime.lastTouch && performance.now() - runtime.lastTouch.at < 800) {
        to = { x: runtime.lastTouch.x, y: runtime.lastTouch.y };
      } else {
        to = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      }

      // Category cards, menu items, product links
      var anchor = target.closest('a[href]') || (target.matches('a[href]') ? target : null);
      var href = anchor ? anchor.getAttribute('href') : null;
      var isNavigatingLink = false;
      if (anchor && href && !href.startsWith('#') && !href.startsWith('javascript:') && anchor.target !== '_blank' && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
        isNavigatingLink = true;
      }

      var merlinTrigger = target.closest('[data-merlin-trigger]');

      if (isNavigatingLink) {
        event.preventDefault();
        event.stopPropagation();
        var fullHref = anchor.href;
        var navigated = false;
        var doNavigate = function () {
          if (navigated) return;
          navigated = true;
          if (typeof window.__TEST_NAV_HANDLER__ === 'function') {
            window.__TEST_NAV_HANDLER__(fullHref);
            return;
          }
          window.location.href = fullHref;
        };
        var safetyTimer = setTimeout(doNavigate, 290);
        startMagicRun(from, to, 220, function () {
          clearTimeout(safetyTimer);
          doNavigate();
        });
        return;
      }

      if (merlinTrigger && !target.closest('#merlin-fairy-presence')) {
        event.preventDefault();
        event.stopPropagation();
        var opened = false;
        var doOpen = function () {
          if (opened) return;
          opened = true;
          runtime.executingAction = true;
          merlinTrigger.click();
          setTimeout(function () { runtime.executingAction = false; }, 200);
        };
        var safetyTimer = setTimeout(doOpen, 290);
        startMagicRun(from, to, 220, function () {
          clearTimeout(safetyTimer);
          doOpen();
        });
        return;
      }

      // Other interactive elements (buttons, pills, etc.)
      startMagicRun(from, to, 220, null);
    }
    function onPageTouchStart(event) {
      if (runtime.pointer || !canTrack() || reducedQuery.matches || event.touches.length === 0) return;
      var touch = event.touches[0];
      var target = touch.target;
      if (target instanceof Element && target.closest('[data-merlin-fairy]')) return;
      runtime.lastTouch = { x: touch.clientX, y: touch.clientY, at: performance.now() };
      var old = runtime.hover;
      runtime.hover = {
        x: touch.clientX,
        y: touch.clientY,
        smoothX: old ? old.smoothX : touch.clientX,
        smoothY: old ? old.smoothY : touch.clientY,
        at: performance.now(),
        isTouch: true
      };
      scheduleFrame();
    }
    function onPageTouchMove(event) {
      if (runtime.pointer || !canTrack() || reducedQuery.matches || event.touches.length === 0) return;
      if (!runtime.hover || !runtime.hover.isTouch) return;
      var touch = event.touches[0];
      runtime.hover.x = touch.clientX;
      runtime.hover.y = touch.clientY;
      runtime.hover.at = performance.now();
      scheduleFrame();
    }
    function onPageTouchEnd() {
      if (runtime.hover && runtime.hover.isTouch) {
        runtime.hover = null;
        clearTether();
      }
    }
    function onPagePointerMove(event) {
      if (event.pointerType !== 'mouse' || !canTrack() || runtime.pointer || reducedQuery.matches) return;
      var old = runtime.hover;
      runtime.hover = {
        x: event.clientX,
        y: event.clientY,
        smoothX: old ? old.smoothX : event.clientX,
        smoothY: old ? old.smoothY : event.clientY,
        at: performance.now(),
        isTouch: false
      };
      scheduleFrame();
    }
    function resolveCanonicalTrigger() {
      var candidates = [];
      if (/\/products\//.test(window.location.pathname)) candidates.push('[data-merlin-trigger="product"]');
      if (/\/collections\//.test(window.location.pathname)) candidates.push('[data-merlin-trigger="collection"]');
      if (document.body.classList.contains('template-index')) candidates.push('[data-merlin-trigger="hero"]');
      candidates.push('[data-merlin-trigger="homepage_strip"]', '[data-merlin-trigger="header"]', '[data-merlin-trigger="cart"]');
      for (var i = 0; i < candidates.length; i += 1) {
        var node = document.querySelector(candidates[i]);
        if (node && !node.closest('[data-merlin-fairy]')) return node;
      }
      return null;
    }
    function activateMerlin() {
      if (performance.now() < runtime.suppressClickUntil || performance.now() < runtime.ignoreClickUntil || runtime.state === 'opening_merlin' || runtime.panelWasOpen) return;
      hideWelcome();
      var canonical = resolveCanonicalTrigger();
      if (!canonical) return;
      cancelMaterialization(); clearTimer('openingTimer'); clearTether();
      setState('opening_merlin');
      canonical.click();
      runtime.openingTimer = setTimeout(function () { runtime.openingTimer = 0; if (runtime.state === 'opening_merlin') setState('idle'); }, 900);
    }
    function onPointerDown(event) {
      if (event.button > 0 || event.isPrimary === false || runtime.paused || runtime.panelWasOpen || runtime.state === 'opening_merlin') return;
      var beganOnPaintedFairy = event.target instanceof Element && event.target.closest('[data-fairy-puppet]');
      if (beganOnPaintedFairy) runtime.ignoreClickUntil = 0;
      if (event.pointerType === 'touch' && !beganOnPaintedFairy) {
        var previousPointerEvents = root.style.pointerEvents;
        root.style.pointerEvents = 'none';
        var beneath = document.elementFromPoint(event.clientX, event.clientY);
        root.style.pointerEvents = previousPointerEvents;
        if (beneath && isPhotoSurface(beneath)) {
          runtime.ignoreClickUntil = performance.now() + 650;
          return;
        }
      }
      hideWelcome();
      cancelMaterialization(); clearTimer('settleTimer'); clearTether(); clearMagic();
      runtime.hover = null;
      runtime.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, baseX: runtime.position.x, baseY: runtime.position.y, moved: false };
      try { trigger.setPointerCapture(event.pointerId); } catch (_) {}
    }
    function onPointerMove(event) {
      var pointer = runtime.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      var dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      if (!pointer.moved && Math.hypot(dx, dy) < 7) return;
      pointer.moved = true;
      runtime.suppressClickUntil = performance.now() + 460;
      setState('dragging'); root.style.transition = 'none';
      setPosition(pointer.baseX + dx, pointer.baseY + dy, Math.max(-8, Math.min(8, dx * .06)));
      event.preventDefault();
    }
    function finishPointer(event) {
      var pointer = runtime.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      runtime.pointer = null;
      try { trigger.releasePointerCapture(event.pointerId); } catch (_) {}
      if (pointer.moved) { runtime.suppressClickUntil = performance.now() + 460; finalizeDrop(); }
    }
    function syncPanel() {
      var open = panel && panel.classList.contains('is-active');
      runtime.panelWasOpen = Boolean(open);
      if (open) {
        stopMessageCycle();
        hideWelcome();
        cancelMaterialization(); clearTimer('settleTimer'); clearTimer('openingTimer');
        runtime.pointer = null; runtime.hover = null; clearTether();
        // A pulse for the genuine opening CTA may finish; panel controls never start new magic.
        setState('panel_open');
      } else if (runtime.state === 'panel_open') {
        if (runtime.paused) setState('suspended');
        else { setState('idle'); startMessageCycle(); }
      }
    }
    function suspend() {
      runtime.paused = true;
      stopMessageCycle();
      stopFrames(); cancelMaterialization(); clearTimer('settleTimer'); clearTimer('openingTimer');
      runtime.pointer = null; runtime.hover = null; clearTether(); clearMagic();
      hideWelcome();
      setState('suspended');
    }
    function resume() {
      if (!runtime.paused) return;
      runtime.paused = false;
      startMessageCycle();
      cacheGeometry(); setPosition(runtime.position.x, runtime.position.y, 0);
      syncPanel();
      if (runtime.panelWasOpen) setState('panel_open');
      else materialize(false);
    }
    function onVisibilityChange() { if (document.visibilityState === 'hidden') suspend(); else resume(); }
    function setQuality() {
      var limited = navigator.hardwareConcurrency <= 2 || navigator.deviceMemory <= 2 || (navigator.connection && navigator.connection.saveData);
      var quality = reducedQuery.matches || limited ? 'reduced' : runtime.viewport.width >= 1440 ? 'high' : 'standard';
      root.dataset.quality = quality;
      [trail, tether, magic].forEach(function (node) { if (node) node.dataset.quality = quality; });
      if (reducedQuery.matches) { cancelMaterialization(); clearTether(); clearMagic(); }
    }

    cacheGeometry(); setQuality();
    if (welcome) {
      welcome.addEventListener('click', activateMerlin);
      welcome.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activateMerlin(); }
      });
    }
    trigger.addEventListener('pointerdown', onPointerDown, { passive: true });
    trigger.addEventListener('pointermove', onPointerMove, { passive: false });
    trigger.addEventListener('pointerup', finishPointer, { passive: true });
    trigger.addEventListener('pointercancel', finishPointer, { passive: true });
    trigger.addEventListener('click', activateMerlin);
    document.addEventListener('touchstart', onPageTouchStart, { passive: true });
    document.addEventListener('touchmove', onPageTouchMove, { passive: true });
    document.addEventListener('touchend', onPageTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onPageTouchEnd, { passive: true });
    document.addEventListener('pointermove', onPagePointerMove, { passive: true });
    document.addEventListener('click', handleActionableClick, { capture: true });
    document.addEventListener('pointerleave', function () {
      if (!runtime.hover || !runtime.hover.isTouch) { runtime.hover = null; clearTether(); }
    }, { passive: true });
    window.addEventListener('blur', function () { runtime.hover = null; clearTether(); });
    window.addEventListener('resize', scheduleClamp, { passive: true });
    window.addEventListener('orientationchange', scheduleClamp, { passive: true });
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', function () { writePageMarker(pageIdentity()); suspend(); });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      // No other store page has run since this document left: the visitor
      // returned from outside the site. Internal history has another PAGE_KEY.
      var externalReturn = readPageMarker() === pageIdentity();
      if (externalReturn) {
        try { window.sessionStorage.removeItem(WELCOME_KEY); } catch (_) {}
        clearVisitMarker();
        // The theme's existing pageshow reload must carry this signal forward.
        writeStorage(REENTRY_KEY, 'true', true);
      }
      writePageMarker(pageIdentity());
      resume();
      if (externalReturn && !runtime.panelWasOpen) materialize(true);
    });
    reducedQuery.addEventListener?.('change', setQuality);
    if (panel) { runtime.observer = new MutationObserver(syncPanel); runtime.observer.observe(panel, { attributes: true, attributeFilter: ['class'] }); }
    if (magic) magic.addEventListener('animationend', function (event) { if (event.target.matches('[data-magic-impact]') && !runtime.magicRun) { magic.dataset.active = 'false'; magic.dataset.state = 'hidden'; } });

    prepareWelcomeEntry();
    var first = !readVisitMarker();
    writeVisitMarker('true');
    var saved = first ? null : readPosition();
    var anchor = saved || chooseAnchor();
    root.style.transition = 'none';
    setPosition(anchor.x, anchor.y, 0);
    void root.offsetHeight;
    root.style.transition = 'none';
    syncPanel();
    startMessageCycle();
    if (!runtime.panelWasOpen) materialize(first);
    else showWelcome(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
